import type { AppMeta } from "@calcom/types/App";

import _package from "./package.json";

export const metadata = {
  name: "Supportly",
  description: _package.description,
  installed: true,
  category: "automation",
  categories: ["automation"],
  logo: "icon.png",
  publisher: "Schedly, LLC",
  slug: "supportly",
  title: "Supportly",
  type: "supportly_other",
  url: "https://app.supportly.io",
  variant: "other",
  email: "info@schedly.io",
  dirName: "supportly",
  isOAuth: true,
} as AppMeta;

export default metadata;
